import { Injectable, computed, inject } from '@angular/core';
import { TenantRoles } from '@sal/shared/domain/value-objects';
import { ThemeService } from './theme.service';
import { IDesignSet } from '../interfaces/IDesignSet';

const SAG_DESIGN: IDesignSet = {
    appName: 'Siemens Address Library',
    logoUrl: 'styles/assets/tenants_logos/sie-logo-petrol-rgb.svg',
    salLogoUrl: 'styles/assets/logo/sal-logo-orange.png',
    pinUrl: '/assets/pins/active_pin_siemens.svg',
    infoFiles: [
        {
            title: 'app.performancedescription',
            keyEN: 'Informations/SAL_service_description_en.pdf',
            keyDE: 'Informations/SAL_service_description_de.pdf'
        },
        {
            title: 'app.versions',
            keyEN: 'Informations/SAL-Version.pdf',
            keyDE: 'Informations/SAL-Version.pdf'
        }
    ]
};

const ENERGY_DESIGN: IDesignSet = {
    appName: 'Siemens Energy Address Library',
    logoUrl: 'styles/assets/tenants_logos/SE_Logo_White_RGB.png',
    salLogoUrl: 'styles/assets/logo/energy_sal_header_logo.png',
    pinUrl: '/assets/pins/active_pin_energy.svg',
    infoFiles: [
        {
            title: 'app.performancedescription',
            keyEN: 'Informations/SAL_service_description_for_Siemens-Energy_en.pdf',
            keyDE: 'Informations/SAL_service_description_for_Siemens-Energy_en.pdf'
        },
        {
            title: 'app.versions',
            keyEN: 'Informations/SAL-Version.pdf',
            keyDE: 'Informations/SAL-Version.pdf'
        }
    ]
};

const SHS_DESIGN: IDesignSet = {
    ...SAG_DESIGN,
    appName: 'Siemens Healthineers Address Library',
    logoUrl: 'styles/assets/tenants_logos/Healthineers_logo.png',
    pinUrl: '/assets/pins/active_pin_healthineers.svg'
};

@Injectable({
    providedIn: 'root'
})
export class DesignService {
    private readonly themeService = inject(ThemeService);

    // Uses the same source as the body theme class, so the pin/logo always match what's
    // visually applied (including the sessionStorage dev override), not just the auth tenant role.
    public readonly designSet = computed(() => this.getDesignSet(this.themeService.resolveActiveTheme()));

    private getDesignSet(tenantRole: TenantRoles | null): IDesignSet {
        switch (tenantRole) {
            case TenantRoles.SE:
                return ENERGY_DESIGN;
            case TenantRoles.SHS:
                return SHS_DESIGN;
            case TenantRoles.SAG:
            default:
                return SAG_DESIGN;
        }
    }
}
